import { useEffect, useState } from "react";
import UserSignup from "./UserSignup";
import StudentSignup from "./StudentSignup";
import { FaTimes } from "react-icons/fa";
import "./Signup.css";

function Signup({ onClose, onBackToLogin, embedded = false }) {
  const [signupUserType, setSignupUserType] = useState("client");

  useEffect(() => {
    const oauthUserType = sessionStorage.getItem("oauthAuthUserType");
    if (oauthUserType === "client" || oauthUserType === "student") {
      setSignupUserType(oauthUserType);
      sessionStorage.removeItem("oauthAuthUserType");
    }
  }, []);

  const LeftPanel = (
    <div className="main-signup-left-panel">
      {!embedded && (
        <button className="main-signup-modal-close" onClick={onClose}>
          <FaTimes />
        </button>
      )}

      <div className="main-signup-type-toggle">
        <div className={`main-signup-slider ${signupUserType}`} />

        <button
          className={signupUserType === "client" ? "active" : ""}
          onClick={() => setSignupUserType("client")}
        >
          Client
        </button>

        <button
          className={signupUserType === "student" ? "active" : ""}
          onClick={() => setSignupUserType("student")}
        >
          Student
        </button>
      </div>

      {signupUserType === "client" ? (
        <UserSignup embedded onClose={onClose} onBackToLogin={onBackToLogin} />
      ) : (
        <StudentSignup embedded onClose={onClose} onBackToLogin={onBackToLogin} />
      )}
    </div>
  );

  if (embedded) return LeftPanel;

  return (
    <div className="main-signup-modal-overlay" onClick={onClose}>
      <div
        className="main-signup-modal-box"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="main-signup-modal-split">
          {LeftPanel}

          <div className="main-signup-right-panel">
            <div className="auth-brand-overlay">
              <div className="auth-brand-orb">✨</div>
              <h2 className="auth-brand-title">Start building<br />something <span className="auth-brand-ai">great</span></h2>
              <p className="auth-brand-sub">
                Join founders using AI to validate ideas, map strategy, and launch
                faster with MarsMate AI.
              </p>
              <ul className="auth-brand-features">
                <li><span className="auth-feature-check">✓</span> Validate your business idea in minutes</li>
                <li><span className="auth-feature-check">✓</span> Generate strategy mind maps with AI</li>
                <li><span className="auth-feature-check">✓</span> Get investor-ready PDF reports</li>
                <li><span className="auth-feature-check">✓</span> Access ready-made tech modules</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signup;
